export default "__VITE_ASSET__CYSLPKKz__"